Bingo.TextField = {};

Bingo.TextField.init = () => {
    // Textfield common
    $(document).on('focusin', '.js-textField__formElement', function () {
        $(this).closest('.js-textField').addClass('-focused');
    });
    $(document).on('focusout', '.js-textField__formElement', function () {
        $(this).closest('.js-textField').removeClass('-focused');
    });
    $(document).on('change', '.js-textField__formElement', function () {
        if ($(this).val() !== '') {
            $(this).closest('.js-textField').addClass('-labelUp');
        } else if (!$(this).closest('.js-textField').hasClass('js-textField__fixedLabelUp')) {
            $(this).closest('.js-textField').removeClass('-labelUp');
        }
    });
    // For dropdown in textField
    $('.js-textField__dropDown').on('show.bs.dropdown', function () {
        $(this).find('.js-textField[data-toggle="dropdown"]').addClass('-focused');
    });
    $('.js-textField__dropDown').on('hide.bs.dropdown', function () {
        $(this).find('.js-textField[data-toggle="dropdown"]').removeClass('-focused');
    });

    $(document).on('change   ', 'select.A-select', function () {
        if ($(this).parent().find('.A-textField__formElement').text().length > 0) {
            $(this).closest('.js-textField').addClass('-labelUp');
        } else {
            $(this).closest('.js-textField').removeClass('-labelUp');
        }
    });
};

Bingo.TextField.labelUpCheck = () => {
    $('.js-textField__formElement').each(function () {
        if ($(this).val() !== '') {
            $(this).closest('.js-textField').addClass('-labelUp');
        }
    });
};
